import React, { useState } from "react";
import { Modal, Col, Button, Form } from "react-bootstrap";
import styled from "styled-components";

const ElevatedModal = styled(Modal)`
  z-index: 99999;
  font-family: "YEKAN-BAKH-MEDIUM";
  text-align: center;
`;

const Check = styled(Form.Check)`
    display: inline;
`;

function DeleteInputPrompt({
    title = "اخطار حذف",
    description = "آیا از حذف این آیتم مطمئن هستید؟",
    actionText = "حذف کن",
    isOpen,
    onClose,
    onActionTap,
    ...rest
}) {
    const [warehouseSelected, setWarehouseSelected] = useState(true);

    return (
        <ElevatedModal
            show={isOpen}
            size='sm'
            centered
            animation={false}
            onHide={onClose}
            {...rest}
        >
            <Modal.Header closeButton>
                <Modal.Title className='w-100 d-flex justify-content-center align-items-center'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"row p-1"}>
                    <Col md={12}>
                        <p>{description}</p>
                    </Col>
                    {/* <Col md={12}>
                        <Check
                            type="checkbox"
                            id='is_active'
                            className='me-3'
                            onChange={(e) => setWarehouseSelected(e.target.checked)}
                            checked={warehouseSelected}
                        />
                        <label htmlFor='is_active'>
                            بروز رسانی انبار
                        </label>
                    </Col> */}
                    <Col md={12}>
                        <Button
                            variant='danger'
                            size={"lg"}
                            onClick={() => onActionTap?.(warehouseSelected)}
                            className={"w-100 mt-3"}
                        >
                            {actionText}
                        </Button>
                    </Col>
                </div>
            </Modal.Body>
        </ElevatedModal>
    );
}

export default DeleteInputPrompt;
